import { createI18n } from 'vue-i18n';
import en from './en';
import pa from './pa';

/**
 * Punjabi-first i18n instance. Gurmukhi is the only active surface language;
 * English exists purely as a fallback so a missing translation key never
 * renders blank. Legacy mode is off — composition API + setup syntax only.
 */
export const i18n = createI18n({
  legacy: false,
  locale: 'pa',
  fallbackLocale: 'en',
  messages: { en, pa },
  // Silence missing-key warnings in dev — fallback is doing its job. Anything
  // truly missing surfaces visually as the English word.
  missingWarn: false,
  fallbackWarn: false,
});

export type LocaleMessages = typeof en;

/** Stand-alone `t` for non-component code (validators, services) that runs
 *  outside a Vue setup scope where `useI18n()` is unavailable. */
export const t: (key: string, named?: Record<string, unknown>) => string = (key, named) =>
  i18n.global.t(key, named ?? {}) as string;
